<template>
    <div class="error-field error-field__state" v-if="errorByKey(field)">
        <span v-html="errorByKey(field).msg"/>
    </div>
</template>
<script>
    import {mapGetters} from 'vuex';

    export default {
        name: 'ErrorState',
        props: {
            field: String
        },
        computed: {
            ...mapGetters('error', ['errorByKey']),
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/error/ErrorState.vue